import { Button, ButtonGroup, Divider, Intent, Popover, PopoverInteractionKind, Position, Tooltip } from "@blueprintjs/core"
import { ID, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { ClipboardCopyBtn } from "src/libs/useful"
import { __, getID } from "src/libs/utilities"
import { defaultSection } from "src/modules/pe-landing-module/data/defaults/defaultSection"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingContent, ILandingSection, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import MeatSelectorList from "./MeatSelectorList"
import { ISectionEditProps } from "./SectionAddButton"
import createMeat from "./utils/createMeat"
import updateHistory from "./utils/updateHistory"

/* Protopia Ecosystem component */ 
const SectionEditPanel = (props: ISectionEditProps): JSX.Element => {
    const sizes = useLandingSize()
    return sizes.width > WINDOW_WIDTH.TABLET
        ?
        <SectionEditScreen {...props} />
        :
        <SectionEditMobile {...props} />
}
const SectionEditMobile = (props: ISectionEditProps): JSX.Element => {
    const onOpen = () => {

    }
    return <div className="position-absolute top left ">
        <div className='landing-section-edit-form'>
            <Popover
                position="bottom"
                content={ <SectionEditButtons {...props} /> }
            >
                <div className="tool-pallete">
                    <div className="tools"> 
                        <Button
                            intent={ Intent.DANGER }
                            icon={ "chevron-down" }
                            variant="solid"
                            onClick={ onOpen } 
                        />
                    </div>
                </div>
            </Popover>
        </div>
    </div> 
}
const SectionEditScreen = (props: ISectionEditProps): JSX.Element => { 
    return <div className="landing-section-edit-form-container">
        <div className='landing-section-edit-form pe-surface2'>
            <SectionEditButtons {...props} />
        </div>
    </div>
}
const SectionEditButtons = (props: ISectionEditProps): JSX.Element => {
    const currentLanding:ILanding = useLandingStore((state: ILandingStore) => state.currentLanding) 
    const isHidden = false 
     
    const onDouble = () => {
        console.log( "onDouble" )
        const historyStep: IHistoryStep = {
            data: { 
                ...(currentLanding.sections[props.i]), 
                id: getID( "section" ) 
            },
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Duplicate section",
        }  
        currentLanding.sections.splice( 
            props.i + 1, 
            0,
            historyStep.data
        ) 
        updateHistory( historyStep, currentLanding )
    }
    const onRnv = () => { 
        const historyStep: IHistoryStep = {
            data:  null,
            prevData: props.section,
            type: HISTORY_TYPE.SECTION,
            title : "Remove section",
        }
        const sections = currentLanding.sections.filter((sec, i) => props.section?.id !== sec.id )
        const newLanding = {
            ...currentLanding,
            sections 
        }  
        
        console.log( props.section?.id )
        console.log( sections )
        
        updateHistory( historyStep, newLanding )
    }
    const onSwitchUp = () => {
        console.log( "onSwitchUp" )
        const historyStep: IHistoryStep = {
            data:  null,
            prevData: props.section,
            type: HISTORY_TYPE.SECTION,
            title : "Switch section to prev",
        }
        const section = currentLanding.sections.splice(props.i, 1,)
        currentLanding.sections.splice(props.i - 1, 0, section[0])
        updateHistory( historyStep, currentLanding )
    }
    const onSwitchDown = () => {
        console.log( "onSwitchUp" )
        const historyStep: IHistoryStep = {
            data:  null,
            prevData: props.section,
            type: HISTORY_TYPE.SECTION,
            title : "Switch section to next",
        }
        const section = currentLanding.sections.splice(props.i, 1,)
        currentLanding.sections.splice(props.i + 1, 0, section[0])
        updateHistory( historyStep, currentLanding )
    }

    const openEdit = ( sectionEditTab: SELECT_TYPE, meat: ILandingContent = {} as ILandingContent ) => {
        useLandingStore.setState({  
            curEditModal: {
                ...meat,
                sectionId: props.section?.id, 
                currentEditType: sectionEditTab,
            } 
        })
    }
    
    const setIsSectionEditOpen = ( sectionEditTab: string, meatID: ID = "" ) => {
        useLandingStore.setState({ 
            isSectionEdit: true, 
            sectionEditTab, 
            sectionEditMeatID: meatID,
            currentEditData: {...defaultSection(), ...props.section}, 
            schema: "Section" 
        })
        
    }

    const onShowSection = ( ) => {
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Show|hide section",
        } 
        const newLanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((sec, i) => {
                if( props.i === i ) {
                    historyStep.prevData = sec
                    historyStep.data = {
                        ...sec,
                        isHidden: !currentLanding.sections[i].isHidden
                    }  
                    return historyStep.data as ILandingSection
                }
                return sec
            })
        } 
        updateHistory( historyStep, newLanding )
    }
    const onNewMeat = (evt: any, key: string, n: number = 0) => {
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : __("Add new Meat ") + components()[key].title,
        } 
        const newLanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((sec, i) => {
                if( props.i === i ) {
                    historyStep.prevData = sec
                    historyStep.data = {
                        ...sec,
                        data: [
                            ...sec.data,
                            createMeat(key, n, {}) 
                        ]
                    }
                    return historyStep.data as ILandingSection
                }
                return sec
            })
        }
        updateHistory( historyStep, newLanding ) 
    }
    return <div className="tool-pallette">
        <div className="tools d-flex"> 
            {
                !!props.section && !!props.section.data.length && 
                <ButtonGroup className="mr-0"> 
                    {
                        props.section.data.map(meat => {
                            const data =  components()[ meat.type ] 
                            return <Tooltip
                                key={meat.id}
                                intent={Intent.PRIMARY}
                                position="top-left"
                                content={__(data.title)}
                            >
                                <Button
                                    intent={Intent.NONE}
                                    tab-bar-id={"types"}
                                    onClick={() => openEdit(SELECT_TYPE.CONTENT, meat)}
                                > 
                                    <img
                                        src={ data.icon }
                                        height={14}
                                        className="svg-force-contrast landing-icon my-2"
                                        style={{
                                            height: 14,
                                            opacity: 1,
                                        }}
                                        alt={__( data.title || "Empty canvas" )}
                                    /> 
                                </Button>
                            </Tooltip>
                        })
                    }
                    <Tooltip
                        intent={Intent.PRIMARY}
                        position="top-left"
                        content={__("Append Meat to Section")}
                    >
                        <Popover 
                            position={Position.BOTTOM_LEFT}
                            interactionKind={PopoverInteractionKind.CLICK}
                            content={<MeatSelectorList onClick={onNewMeat}/>} 
                            portalClassName="z-index-130" 
                        >
                            <Button
                                intent={Intent.NONE}
                                className={`ml-0`}
                                icon="plus"
                                tab-bar-id={"types"} 
                            > 
                            </Button>
                        </Popover>
                    </Tooltip>
                </ButtonGroup>
            }
            <ButtonGroup className="mr-0">
                <Tooltip
                    intent={Intent.PRIMARY}
                    position="top-left"
                    content={__("Duplicate this Section")}
                >
                    <Button
                        intent={Intent.NONE}
                        icon="duplicate"
                        onClick={onDouble} 
                    />
                </Tooltip>
                <Tooltip
                    intent={Intent.PRIMARY}
                    position="top-left"
                    content={__("Settings")}
                >
                    <Popover
                        position={Position.BOTTOM_LEFT}
                        interactionKind={PopoverInteractionKind.HOVER}
                        content={   
                            <ButtonGroup vertical variant="minimal" fill>
                                {/* <Button 
                                    alignText="left" 
                                    className="pr-0" 
                                    onClick={ () => setIsSectionEditOpen( "composition" ) }
                                >
                                    <div className="small d-flex justify-content-between align-items-center pr-1">
                                        {__("Composition")}
                                        <Tag minimal className="ml-3 hint hint--top" data-hint={__("Meats design")}>
                                            <div className="small">
                                                { __(props.section!.designType || SECTION_DESIGN_TYPE.FEED) }
                                            </div>
                                        </Tag>
                                        <Tag minimal className="ml-1 hint hint--top" data-hint={__("Columns count")}>
                                            <div className="small">
                                                { props.section!.composition?.columns || 1 }
                                            </div>
                                        </Tag>
                                        <Tag minimal className="ml-1 hint hint--top" data-hint={__("Width")}>
                                            <div className="small">
                                                { __( ( props.section!.composition?.container || currentLanding.size || DIALOG_SIZE.NORMAL ).toString() ) }
                                            </div>
                                        </Tag>
                                    </div>
                                </Button> */}
                                <Button alignText="left" onClick={ () => openEdit( SELECT_TYPE.TITLE ) }>
                                    <div className="small">
                                        {__("Title and description")}
                                    </div>
                                </Button>
                                <Button alignText="left" onClick={ () => openEdit( SELECT_TYPE.BACKGROUND ) }>
                                    <div className="small">
                                        {__("Smart background")}
                                    </div>
                                </Button>
                                <Button alignText="left" onClick={ () => openEdit( SELECT_TYPE.DELIMITER ) }>
                                    <div className="small">
                                        {__("Bottom delimiter")}
                                    </div>
                                </Button>
                                <Divider />
                                <ClipboardCopyBtn 
                                    data={ props.section }
                                    label={ __("Copy section")} 
                                    type="button"
                                    align="left"
                                    answer={__("Section copy to clipboard")}
                                /> 
                                <Button alignText="left" onClick={ () => {} }>
                                    <div className="small">
                                        {__("Paste section after this")}
                                    </div>
                                </Button>
                            </ButtonGroup> 
                        }
                    > 
                        <Button
                            intent={Intent.NONE}
                            icon={<i className="fas fa-cog"></i>} 
                            className={`ml-0`}
                            tab-bar-id={"title"}
                            onClick={ () => setIsSectionEditOpen( "main" ) }
                        > 
                        </Button>
                    </Popover> 
                </Tooltip>
            </ButtonGroup>
            <ButtonGroup className="mr-0">
                <Tooltip
                    intent={Intent.PRIMARY}
                    position="top-left"
                    content={__(isHidden ? "Show section" : "Hide section")}
                >
                    <Button
                        icon={isHidden ? "eye-open" : "eye-off"}  
                        intent={Intent.NONE}
                        onClick={ onShowSection }
                    /> 
                </Tooltip>
                {
                    props.i !== 0 && 
                    <Tooltip
                        intent={Intent.PRIMARY}
                        position="top-left"
                        content={__("switch up")}
                    >
                        <Button
                            icon="arrow-up" 
                            intent={Intent.NONE}
                            onClick={onSwitchUp}
                        /> 
                    </Tooltip>
                }
                {
                    props.i < currentLanding.sections.length - 1 &&
                    <Tooltip
                        intent={Intent.PRIMARY}
                        position="top-left"
                        content={__("switch down")}
                    >
                        <Button
                            icon="arrow-down" 
                            intent={Intent.NONE}
                            onClick={onSwitchDown}
                        />
                    </Tooltip>
                } 
            </ButtonGroup>
            <ButtonGroup> 
                <Tooltip
                    intent={Intent.PRIMARY}
                    position="top-left"
                    content={__("Remove Section")}
                >
                    <Button
                        intent={Intent.DANGER}
                        icon="trash"
                        onClick={onRnv}
                    />
                </Tooltip>
            </ButtonGroup>
        </div>  
    </div>
}
export default SectionEditPanel